<div class="w-full search-container d-flex fl-al-center fl-justify-between" [style.border-bottom]="isInputFocused ? '1px solid #d8dfeb' : ''">
  <div class="form-group form-main form-group-overrides width-100per mb-0 col-span-2">
    <div class="div-group width-100per">
      <mat-form-field
        class="temp-alignment"
        id="access-manager-matAutoComplete"
        matTooltipClass="add-member-tooltip"
        [ngClass]="{ 'disable-search': disableSearch, 'white-background': isInputFocused, 'temp-alignment': !isInputFocused }"
      >
        @if (isInputFocused) {
        <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
          <img src="assets/images/search-blue.svg" width="20px" height="20px" />
        </div>
        } @if (!isInputFocused) {
        <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
          <img src="assets/images/search-gray.svg" width="20px" height="20px" />
        </div>
        }

        <input
          type="text"
          matInput
          #myInput
          aria-label="Number"
          [disabled]="disableSearch"
          [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto"
          (input)="onMemberSearch($event.target.value)"
          [placeholder]="textBoxPlaceHolder"
          class="addMember global-input text-base font-sans font-normal text-[#53565B]"
          [ngClass]="{ 'text-[#53565B66]': disableSearch }"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
        />

        @if (connectionUserFormControl.value) {
        <div matSuffix (click)="clearInput()">
          <mat-icon class="close-input-icon text-[#898F9E]">close</mat-icon>
        </div>
        }

        <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main global-search-scroll-main">
          <div class="max-h-[252px] overflow-y-auto m-3" style="display: flex; flex-wrap: wrap">
            @for(file of nonDocumentAttachmentList | filterList : searchText; track file.id){
            <mat-option
              (onSelectionChange)="onFileSelected($event, file)"
              class="w-[206px] h-[160px] mr-2 mb-2 rounded-[12px] border border-[#D3DCE8] p-0"
            >
              <div class="image-div-container" style="width: 206px">
                <div class="files-list relative hover:bg-[#5475C026] hover:border">
                  <div class="donwlaod-continer">
                    <div style="display: flex; flex-direction: column">
                      <file-extension-preview
                        style="width: 100%; background-color: #f4f4f4; border-radius: 8px 8px 0px 0px; cursor: pointer; text-align: center"
                        [IconName]="nmaterialIconName(file)"
                        [link]="file?.link"
                        [is_large_icon]="false"
                        [link_available]="true"
                        [file]="file"
                        [formFileExtension]="true"
                        [isActive]="false"
                      >
                      </file-extension-preview>
                    </div>

                    <div
                      class="mobile-divdownload-cross"
                      style="
                        height: 56px;
                        display: flex;
                        justify-content: space-between;
                        border-top: 1px solid rgba(211, 220, 232, 0.7);
                        padding: 12px;
                      "
                    >
                      <div class="flex flex-col">
                        <p
                          class="text-[13px] font-bold text-[#010B18] m-0"
                          style="line-height: 16px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 25px"
                          [matTooltip]="file?.form_name"
                        >
                          {{ file?.form_name | truncateStrPipe : 20 }}
                        </p>
                        <p
                          class="text-[10px] font-medium text-[#898F9E] m-0"
                          style="line-height: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 25px"
                          [matTooltip]="file?.type"
                        >
                          {{ file?.type | truncateStrPipe : 20 }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-option>
            } @if(nonDocumentAttachmentList.length && (nonDocumentAttachmentList | filterList : searchText).length === 0){
            <mat-option>
              <p class="text-[#898F9E] text-center">No results found</p>
            </mat-option>
            }
          </div>
          <div class="border border-[#D3DCE8] rounded h-[90px] text-center m-3 cursor-pointer pt-6" (click)="openFileUpload()">
            <img class="h-[32px] w-[32px] mb-2" src="assets/images/upload-file-inbox-blue.svg" />
            <p class="text-[#1e1e20] text-[10px] font-semibold">Upload Files</p>
          </div>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>
